import { render, staticRenderFns } from "./OldMutualFooter.vue?vue&type=template&id=4cfda379&scoped=true"
import script from "./OldMutualFooter.vue?vue&type=script&lang=js"
export * from "./OldMutualFooter.vue?vue&type=script&lang=js"
import style0 from "./OldMutualFooter.vue?vue&type=style&index=0&id=4cfda379&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfda379",
  null
  
)

export default component.exports